import React from "react";
import {
  CheckCircle2,
  Clock,
  Loader2,
  XCircle,
  AlertTriangle,
} from "lucide-react";
import { Badge } from "@/shared/components/ui/badge";

export const STATUS_CONFIG = {
  success: {
    icon: CheckCircle2,
    color: "bg-emerald-100 text-emerald-700 border-emerald-200",
    label: "Success",
  },
  pending: {
    icon: Clock,
    color: "bg-amber-100 text-amber-700 border-amber-200",
    label: "Pending",
  },
  processing: {
    icon: Loader2,
    color: "bg-blue-100 text-blue-700 border-blue-200",
    label: "Processing",
    animate: true,
  },
  failed: {
    icon: XCircle,
    color: "bg-red-100 text-red-700 border-red-200",
    label: "Declined",
  },
  expired: {
    icon: AlertTriangle,
    color: "bg-slate-100 text-slate-700 border-slate-200",
    label: "Expired",
  },
  cancelled: {
    icon: XCircle,
    color: "bg-slate-100 text-slate-700 border-slate-200",
    label: "Cancelled",
  },
  declined: {
    icon: XCircle,
    color: "bg-red-100 text-red-700 border-red-200",
    label: "Declined",
  },
};

export const TransactionStatusBadge = ({ status, t, className = "" }) => {
  const statusKey = (status || "").toLowerCase();
  const config = STATUS_CONFIG[statusKey] || STATUS_CONFIG.pending;
  const StatusIcon = config.icon;

  const label = t
    ? t(statusKey) !== statusKey
      ? t(statusKey)
      : config.label
    : config.label;

  return (
    <Badge
      className={`${config.color} gap-1 border text-xs shadow-none ${className}`}
    >
      <StatusIcon className={`h-3 w-3 ${config.animate ? "animate-spin" : ""}`} />
      <span className="hidden sm:inline">{label}</span>
    </Badge>
  );
};
